export default "__VITE_ASSET__55e31b14__"